exports = module.exports = require("../../../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".imosSdk-video{width:100%!important;height:100%!important;border-width:0!important}", ""]);

// exports
